import axios from 'axios';

// Reportes es un servicio independiente del backend principal.
const baseURL = (process.env.REACT_APP_REPORTS_API_URL || process.env.REACT_APP_REPORTES_API_URL || '/reportes-api').trim().replace(/\/+$/, '');
const api = axios.create({ baseURL: baseURL.endsWith('/api') ? baseURL : `${baseURL}/api` });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
export default api;
